import React, { useState, useEffect, useRef } from 'react';
import { Button, Form, Input, InputGroup, InputGroupAddon, Spinner } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { BrowserMultiFormatReader, BarcodeFormat, DecodeHintType } from '@zxing/library';
import { ReactComponent as Camera } from 'bootstrap-icons/icons/camera.svg';
import { handleResponse } from '../utils/handlers';
import { BusyIndicator } from './BusyIndicator';

import styles from './ConsignmentLookup.module.css';

const hints = new Map();
const formats = [
    BarcodeFormat.AZTEC,
    BarcodeFormat.CODABAR,
    BarcodeFormat.CODE_128,
    BarcodeFormat.CODE_39,
    BarcodeFormat.CODE_93,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.EAN_8,
    BarcodeFormat.ITF,
    BarcodeFormat.MAXICODE,
    BarcodeFormat.PDF_417,
    BarcodeFormat.QR_CODE,
    BarcodeFormat.RSS_14,
    BarcodeFormat.RSS_EXPANDED,
    BarcodeFormat.UPC_A,
    BarcodeFormat.UPC_E,
    BarcodeFormat.UPC_EAN_EXTENSION
    /*, ...*/
];

hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);

const codeReader = new BrowserMultiFormatReader();
codeReader.hints = hints;

function ConsignmentLookup(props) {

    let history = useHistory();

    const referenceInput = useRef(null);
    const lookupButton = useRef(null);

    const [consignmentReference, setConsignmentReference] = useState('');
    const [decoding, setDecoding] = useState(false);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        referenceInput.current.focus();
    }, []);

    var decode = e => {

        if (decoding) {
            setDecoding(false);
            codeReader.reset();
        } else {
            setDecoding(true);
            codeReader
                .getVideoInputDevices()
                .then((videoInputDevices) => {

                    if (videoInputDevices.length === 0) {
                        setDecoding(false);
                        codeReader.reset();
                        var errorMsg = 'No camera detected.';
                        alert(errorMsg);
                        return Promise.reject(errorMsg);
                    }

                    return codeReader.decodeOnceFromVideoDevice(undefined, 'video');
                })
                .then(result => {
                    console.log(result);
                    setDecoding(false);
                    setConsignmentReference(result.text);
                    codeReader.reset();
                    lookupButton.current.focus();
                    lookUp(result.text);
                })
                .catch(err => console.error(err));
        }
    };

    function lookUp(reference) {

        setBusy(true);
        fetch(`api/consignments/byref/${reference}`,
            {
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(handleResponse)
            .then(data => {

                setBusy(false);

                history.push(`/consignment/${data.consignmentID}`, data);
            })
            .catch(error => {
                setBusy(false);
                if (error !== 'Unauthorized')
                    alert(error);
            });
    };

    function handleLookup(e) {
        if (!consignmentReference || !consignmentReference.trim())
            return;

        lookUp(consignmentReference);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!consignmentReference || !consignmentReference.trim())
            return;

        lookUp(consignmentReference);
    }

    return (
        <React.Fragment>
            {
                decoding &&
                <video
                    id="video"
                    className={styles.camera}
                ></video>
            }
            <Form onSubmit={handleSubmit}>
                <InputGroup>
                    <Input type="text" innerRef={referenceInput} value={consignmentReference} onChange={e => setConsignmentReference(e.target.value)} />
                    <InputGroupAddon addonType="append">
                        <Button color="primary" onClick={decode}><Camera /></Button>
                    </InputGroupAddon>
                </InputGroup>
                <Button type="button" className={styles.btn} color="primary" innerRef={lookupButton} onClick={handleLookup} block>Lookup</Button>
                <Button type="button" className={styles.btn} color="secondary" onClick={e => setConsignmentReference('')} block>Clear</Button>
            </Form>
            <BusyIndicator isBusy={busy} />
        </React.Fragment>
    );
}

export { ConsignmentLookup };